// Needle type tabs for the grouped size picker (snippets/ink-variant-pills.liquid).
// The picker is re-rendered by the server after every selection with the selected
// size's type already open, so the tabs keep no state of their own.
if (!customElements.get('ink-variant-groups')) {
  customElements.define(
    'ink-variant-groups',
    class InkVariantGroups extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        this.setAttribute('data-ready', '');
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-ink-vg-tab]');
          if (!tab || !this.contains(tab)) return;
          this.show(tab.dataset.inkVgTab);
        });
      }

      show(family) {
        this.querySelectorAll('[data-ink-vg-tab]').forEach((tab) => {
          tab.setAttribute('aria-pressed', String(tab.dataset.inkVgTab === family));
        });
        this.querySelectorAll('[data-ink-vg-group]').forEach((group) => {
          group.hidden = group.dataset.inkVgGroup !== family;
        });
      }
    }
  );
}
